import styled from "styled-components";

export const InfoSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const InfoSearchTitle = styled.div`
  display: flex;
  align-items: flex-start;
  min-width: 41.7rem;
  max-width: 47.2rem;
  width: 100%;
`;
